import Immutable from 'immutable';
import {
  FLAG_GETTING_TOLLS,
  GET_TOLLS,
  CLEAR_TOLLS,
  GET_TOLL,
  CLEAR_TOLL,
  FLAG_TOLL_ACTIVITY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_TOLLS:
      return state.setIn(['all', 'loading'], payload);
    case GET_TOLLS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_TOLLS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_TOLL:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_TOLL:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_TOLL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
